import {ON_FINGER_VERIFICATION} from '../constants/ActionTypes';

const INIT_STATE = {
    verificationResponseObj:{}
};


export default (state=INIT_STATE,action) => {
    switch (action.type){
        case ON_FINGER_VERIFICATION: {
          console.log(action.payload);
            return { ...state, verificationResponseObj: action.payload };
        }
        default:
            return state;
    }
}